import { render, staticRenderFns } from "./TopluIslerView.vue?vue&type=template&id=21fba7e7&scoped=true"
import script from "./TopluIslerView.vue?vue&type=script&lang=ts"
export * from "./TopluIslerView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fba7e7",
  null
  
)

export default component.exports